import { Injectable } from '@angular/core'
import {
    ForgotPasswordMutation,
    ForgotPasswordMutationService,
    ForgotPasswordMutationVariables,
    UpdateForgottenPasswordMutation,
    UpdateForgottenPasswordMutationService,
    UpdateForgottenPasswordMutationVariables,
    UpdatePasswordMutation,
    UpdatePasswordMutationService,
    UpdatePasswordMutationVariables,
} from '@app-graphql/schema'
import { InputPublic } from '@app-domains/ui/components/input/input.component.types'
import { Observable } from 'rxjs'
import { Apollo } from 'apollo-angular'

@Injectable({
    providedIn: 'root',
})
export class PasswordService {

    public passwordFormType: InputPublic.Type = 'password'

    public passwordErrorMessages: InputPublic.ErrorMessageRecord = {
        required: 'validation.messages.required',
        minlength: 'validation.messages.min-length-14',
        noNumber: 'validation.messages.no-number',
        noUppercase: 'validation.messages.no-uppercase',
    }

    constructor(
        private forgotPasswordMutationService: ForgotPasswordMutationService,
        private updatePasswordMutationService: UpdatePasswordMutationService,
        private updateForgottenPasswordMutation: UpdateForgottenPasswordMutationService,
    ) {
    }

    public forgotPassword(
        input: ForgotPasswordMutationVariables,
    ): Observable<Apollo.MutateResult<ForgotPasswordMutation>> {
        return this.forgotPasswordMutationService.mutate({ variables: input })
    }

    public updatePassword(
        input: UpdatePasswordMutationVariables,
    ): Observable<Apollo.MutateResult<UpdatePasswordMutation>> {
        return this.updatePasswordMutationService.mutate({ variables: input })
    }

    public updateForgottenPassword(input: UpdateForgottenPasswordMutationVariables)
        : Observable<Apollo.MutateResult<UpdateForgottenPasswordMutation>> {
        return this.updateForgottenPasswordMutation.mutate({ variables: input })
    }

    public changeFormType(): void {
        this.passwordFormType = this.passwordFormType === 'password' ? 'text' : 'password'
    }

}
